<template>
  <div>
  <div class="card mx-md-5 mt-3 mb-3 bg-form">
    <card-header
        :title="getTitle"
        :iconName="'folder2-open'"
    />
    <b-card-body>
      <Announcement :activity="activity"/>
    </b-card-body>
  </div>
  </div>

</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from '@/services/error.service';
import CardHeader from "@/components/common/cardHeader";
import Announcement from "@/views/training/Announcement";

export default {
  components: {
    Announcement,
    CardHeader
  },
  computed: {
    getTitle(){
      if (!this.activity) {
        return "-";
      }
      return `${this.activity.location!==null? this.activity.location +': ': ''}${this.activity?.module?.title}`
    }
  },
  mounted() {
    this.getAnnouncementById();
  },
  data() {
    return {
      activity: null,
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
      if(errors?.length>0) {
        window.scrollTo(0,0);
      }
    },
    getAnnouncementById() {
      trainingService.getAnnouncementById(this.$route.params.id).then(
        (response) => {
          this.activity = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    }
  },
}
</script>